svg {
  width: 1em;
}
